import { baseConfig } from '@adornis/config/baseConfig.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { projectConfig } from '@chancenwerk/config/config.js';
import { ChancenwerkUser } from '@chancenwerk/shared/master-data-management/users/entities/ChancenwerkUser.js';
import { ExternalContactPerson } from '@chancenwerk/shared/master-data-management/users/entities/ExternalContactPerson.js';
import { Student } from '@chancenwerk/shared/master-data-management/users/entities/Student.js';
import { DateTime } from 'luxon';
import { filter, firstValueFrom } from 'rxjs';

// Classes that should not be redirected to NETZ.
const DONT_REDIRECT_CLASSES = [Student._class, ExternalContactPerson._class];

/**
 * Checks if the user should be redirected to NETZ at the beginning of the day.
 */
export async function checkNetzRedirect() {
  if (baseConfig.get('DEPLOYMENT') === 'development') return;

  const user = await firstValueFrom(currentUser().pipe(filter(Boolean)));
  if (!user || !(user instanceof ChancenwerkUser) || DONT_REDIRECT_CLASSES.includes(user._class)) {
    return;
  }

  if (!user.lastActivity?.startOf('day').equals(DateTime.now().startOf('day'))) {
    await registerActivity();
    console.info('User was inactive. Returning to NETZ');
    goTo({ path: projectConfig.get('NETZ_URL'), replaceState: true });
  }

  await registerActivity();
}

/**
 * Registers the user activity for the current day.
 */
export async function registerActivity() {
  await ChancenwerkUser.registerUserActivity()();
}
